const BASE_URL = 'https://retrosive.com';

export interface FaqItem {
  question: string;
  answer: string;
}

export function buildFaqPageSchema(faqs: FaqItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function buildBreadcrumbSchema(
  items: { name: string; path: string }[]
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${BASE_URL}${item.path}`,
    })),
  };
}

export function buildWebPageSchema(opts: {
  path: string;
  name: string;
  description: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${BASE_URL}${opts.path}#webpage`,
    url: `${BASE_URL}${opts.path}`,
    name: opts.name,
    description: opts.description,
    isPartOf: {
      '@type': 'WebSite',
      '@id': `${BASE_URL}/#website`,
      name: 'Retrosive',
      url: BASE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Retrosive',
      url: BASE_URL,
      logo: `${BASE_URL}/logo512.png`,
    },
  };
}

export function buildArticleSchema(opts: {
  path: string;
  headline: string;
  description: string;
  datePublished?: string;
  keywords?: string[];
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: opts.headline,
    description: opts.description,
    url: `${BASE_URL}${opts.path}`,
    mainEntityOfPage: `${BASE_URL}${opts.path}`,
    datePublished: opts.datePublished ?? '2026-05-20',
    dateModified: opts.datePublished ?? '2026-05-20',
    author: {
      '@type': 'Organization',
      name: 'Retrosive',
    },
    publisher: {
      '@type': 'Organization',
      name: 'Retrosive',
      logo: {
        '@type': 'ImageObject',
        url: `${BASE_URL}/logo512.png`,
      },
    },
    keywords: opts.keywords?.join(', '),
  };
}

export function buildItemListSchema(
  items: { name: string; path: string; description: string }[]
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Retrosive tool comparisons',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      url: `${BASE_URL}${item.path}`,
      description: item.description,
    })),
  };
}
